import { reader } from '@woonstad/helpers-utils';

import type { RedactionRect } from './redactionRect';
import { fractionRectToPixelRect } from './imageCoordinates';

export async function burnRedactions(
  file: File,
  rectangles: RedactionRect[],
): Promise<File> {
  if (!file.type.startsWith('image/') || rectangles.length === 0) {
    return file;
  }

  const base64 = await reader(file);

  return new Promise((resolve, reject) => {
    const img = new Image();

    img.onload = () => {
      const { width, height } = img;
      const canvas = document.createElement('canvas');

      canvas.width = width;
      canvas.height = height;

      const ctx = canvas.getContext('2d');

      if (!ctx) {
        resolve(file);

        return;
      }

      ctx.drawImage(img, 0, 0, width, height);

      ctx.fillStyle = '#000000';

      for (const rect of rectangles) {
        const { x, y, width: pw, height: ph } = fractionRectToPixelRect(rect, width, height);

        if (pw <= 0 || ph <= 0) {
          continue;
        }

        ctx.fillRect(x, y, pw, ph);
      }

      canvas.toBlob((blob) => {
        if (blob) {
          resolve(new File([blob], file.name, { type: file.type || 'image/jpeg' }));
        } else {
          resolve(file);
        }
      }, file.type || 'image/jpeg', 0.92);
    };

    img.onerror = () => reject(new Error(`Failed to load image: ${file.name}`));
    img.src = base64;
  });
}
